// Maps IQE project status from API response to UI status

import type { IqeProjectStatus, TestRun } from '../../interfaces/ui';
import type { TestRunResponseData } from '../../interfaces/api/responses/saveProject.response';
import { IQE_PROJECT_STATUS_MAP } from '../../constants';
import { parseDateSafely } from '../../utils';

export function toUiProjectStatus(apiStatus: string): IqeProjectStatus {
  const normalizedStatus = (apiStatus || '').trim().toUpperCase();
  return IQE_PROJECT_STATUS_MAP[normalizedStatus];
}

export function toTestRuns(runData: TestRunResponseData): TestRun {
  const passRateStr = runData.passRate || '0';
  const passRate = parseFloat(passRateStr.replace('%', '')) || 0;

  return {
    transactionId: runData.transactionId,
    operation: runData.operation,
    testCases: parseInt(runData.testCases, 10) || 0,
    failed: parseInt(runData.failed, 10) || 0,
    passRate,
    createdAt: parseDateSafely(runData.createdAt),
  };
}
